<template>
    <keep-alive>
        <Row :seats="row" :flightid="flightid" :seatCountOnRow="seatCountOnRow" :priceMap="priceMap" :text="text" :styling="styling"/>
    </keep-alive>
</template>
<script>
import Row from './Row'
export default {
  props: ['row', 'flightid', 'seatCountOnRow', 'priceMap', 'text', 'styling'],
  components: {
    Row
  }
}
</script>



// WEBPACK FOOTER //
// src/components/RowList.vue